import { buildAssetFromInferredType } from '#pplx/frontend/apps/ask/canvas-shared/utils/inferredAssetTypeUtils.js';
function buildThreadArtifacts(resultAssets) {
    const allAssets = resultAssets.flatMap(({ assets }) => assets);
    return { resultAssets, allAssets, hasAssets: allAssets.length > 0 };
}
function getArtifactName({ caption, location, }) {
    if (caption !== null)
        return caption;
    const locationWithoutQuery = location.split('?', 1)[0] ?? '';
    return locationWithoutQuery.split('/').pop() ?? '';
}
export function toCanvasAsset(artifact) {
    const name = getArtifactName(artifact);
    const paneArtifact = artifact.asset_type === 'EXTERNAL_URL'
        ? {
            uuid: artifact.asset_id,
            asset_type: 'EXTERNAL_URL',
            external_url: { title: name, url: artifact.location },
        }
        : artifact.asset_type === 'AUTOMATION'
            ? {
                uuid: artifact.asset_id,
                asset_type: 'AUTOMATION',
                automation: { title: name },
            }
            : buildAssetFromInferredType({
                assetType: artifact.asset_type,
                filename: name,
                mimeType: artifact.media_type ?? '',
                url: artifact.location,
                uuid: artifact.asset_id,
            });
    return {
        ...paneArtifact,
        backend_uuid_slug: artifact.asset_slug ?? artifact.asset_id,
        created_at: String(artifact.created_at),
        is_primary_asset: true,
        parent_asset_id: artifact.parent_asset_id ?? undefined,
        root_asset_id: artifact.root_asset_id ?? undefined,
        fallback_info: {
            name,
            webview_url: artifact.location,
            preview_image_url: artifact.preview_image_url ?? undefined,
        },
        preview_info: artifact.preview_image_url
            ? [{ type: 'thumbnail', s3_url: artifact.preview_image_url }]
            : undefined,
        ...artifact.asset_data,
    };
}
export function getThreadArtifactsFromEntries(entries, contextUuid) {
    const resultAssets = entries.flatMap((entry) => {
        const assets = entry.assets.filter((asset) => asset.is_primary_asset && asset.uuid);
        return assets.length > 0
            ? [{ result: { backend_uuid: entry.entry_uuid, context_uuid: contextUuid }, assets }]
            : [];
    });
    return buildThreadArtifacts(resultAssets);
}
export function overlayLiveArtifactEntry(serverArtifacts, liveEntry) {
    const entryUuid = liveEntry?.result.backend_uuid;
    const liveArtifacts = (liveEntry?.assets ?? []).filter((artifact) => artifact.is_primary_asset && artifact.uuid);
    if (!entryUuid || liveArtifacts.length === 0)
        return serverArtifacts;
    const liveAssetIds = new Set(liveArtifacts.map(({ uuid }) => uuid));
    return buildThreadArtifacts([
        ...serverArtifacts.resultAssets
            .map(({ result, assets }) => ({
            result,
            assets: assets.filter(({ uuid }) => !liveAssetIds.has(uuid)),
        }))
            .filter(({ assets }) => assets.length > 0),
        { result: liveEntry.result, assets: liveArtifacts },
    ]);
}
//# sourceMappingURL=threadArtifacts.js.map